import { useCallback } from 'react';

import { useTranslate } from '@i18n';
import { Button, ModalBase, ModalBody, ModalFooter, ModalHeader, u } from '@ui';

import { GridAreaControls, withGridAreaScope } from '../../GridAreaControls/GridAreaControls';

import { useSyncFloorModules, useUpdateFloorLayout } from './hooks';

type FloorViewEditorProps = {
    onDismiss: () => void;
};

const FloorViewEditorComponent = ({ onDismiss }: FloorViewEditorProps) => {
    const { handleUpdateFloor } = useUpdateFloorLayout();

    // We want initial layout values be mapped to grid editor.
    useSyncFloorModules();

    const handleSave = useCallback(() => {
        handleUpdateFloor();
        onDismiss();
    }, [handleUpdateFloor, onDismiss]);

    const t = useTranslate();
    return (
        <ModalBase open variant="partial" onDismiss={onDismiss}>
            <ModalHeader>Floor view editor</ModalHeader>
            <ModalBody pb={u(4)}>
                <GridAreaControls />
            </ModalBody>
            <ModalFooter
                secondary={
                    <Button variant="secondary" size="medium" onClick={onDismiss}>
                        {t('generic_ui.close')}
                    </Button>
                }
                primary={
                    <Button variant="primary" size="medium" onClick={handleSave}>
                        {t('generic_ui.save')}
                    </Button>
                }
            />
        </ModalBase>
    );
};

export const FloorViewEditor = withGridAreaScope(FloorViewEditorComponent);
